<!-- src/components/SwamtReport.Vue -->
<template>
  <div v-if="showReport && !loading" class="main">
    <div class="bottom-back">
      <div class="header" v-if="thirdSections && thirdSections.length > 0">
        <div class="header-item">
          <h1 class="total-text big-title">
            {{ totalRatio }}%<span>总正确率</span>
          </h1>
          <h4>整节课训练情况</h4>
        </div>

        <div v-if="thirdSections.length > 1" class="header-item-1">
          <h1 class="total-text">{{ thirdSections[1].ratio.toFixed(0) }}%</h1>
          <h4>自主发音正确率</h4>
        </div>
        <div v-if="thirdSections.length > 2" class="header-item-1">
          <h1 class="total-text">{{ thirdSections[2].ratio.toFixed(0) }}%</h1>
          <h4>提示后发音正确率</h4>
        </div>
      </div>

      <div
          v-for="section in filteredSections2"
          :key="section.one.title"
          class="section-back"
      >
        <h4 class="sub-title">{{ section.one.title }}</h4>
        <div class="letter-rows">
          <div v-for="item in section.one.items" :key="item.letter" class="item">
            <div class="letter-circle">{{ item.letter }}</div>
            <h5 v-for="a in item.accuracys" :key="a.title">
              {{ a.title }} ：{{ a.ratio.toFixed(0) }} %
            </h5>
          </div>
        </div>
        <div
            v-for="item in section.two.items"
            :key="item.letter"
            class="row-square row-sq-2"
        >
          <div class="col-titles-row">
            <div></div>
            <div><p>正确率</p></div>
            <div><p>自主正确率</p></div>
            <div><p>提示后正确率</p></div>
          </div>

          <div
              v-for="row in item.rows"
              :key="row.word_id || row.word" class="s-row col-titles-row"
          >
            <div class="word title-word">{{ row.word }}</div>
            <div class="q-row" v-for="ac in row.accuracys" :key="ac.title">
              <label>{{ ac.ratio.toFixed(0) }}%</label>
            </div>
          </div>
        </div>
      </div>
      <h4 class="sub-title">目标声母整体训练情况</h4>
      <div class="letter-rows">
        <div v-for="item in secondSections" :key="item.initial" class="item">
          <div class="letter-circle">{{ item.initial }}</div>
          <h5 v-for="a in item.accuracys" :key="a.title">
            {{ a.title }} ：{{ a.ratio.toFixed(0) }} %
          </h5>
        </div>
      </div>

      <h4 class="sub-title">目标声母在不同目标词训练情况</h4>
      <div v-for="item in firstSections" :key="item.letter" class="row-square">
        <h1>{{ item.letter }}</h1>
        <div v-for="row in item.rows" :key="row.word_id || row.word" class="s-row">
          <div class="word">{{ row.word }}</div>
          <div class="right">
            <div class="right-row" v-for="ac in row.accuracys" :key="ac.title">
              <div class="pro-back">
                <div
                    v-for="b in blocks"
                    :style="{
                      'background-color':
                        ac.ratio / 20 >= b ? '#279fb1' : '#d9d9d9',
                      'margin-right': b === 5 ? 0 : 2 + 'px',
                    }"
                    class="block-item"
                    :key="b"
                ></div>
              </div>
              <div class="ending">
                <label>{{ ac.ratio.toFixed(0) }}%</label>
                <label class="small-text">{{ ac.title }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="!loading" class="main">
    <h1 class="title-header">今日表现</h1>
    <div v-for="item in manifestations" :key="item.key" class="input-row">
      <label>{{ item.title }}</label>
      <select v-model="item.score">
        <option value="良好">良好</option>
        <option value="普通">普通</option>
        <option value="不佳">不佳</option>
      </select>
    </div>
    <div v-if="uploading" class="loading">
      <div class="loader"></div>
    </div>
    <button v-else @click="onUploadButton" class="star-button">提交</button>
  </div>
</template>
<script>
import {pinyin} from 'pinyin-pro';
import {portalUrl} from '@/static/config';
import 'core-js/actual/array/group-by';
import {calculateAccuracy, aggregateFlows} from "@/unitl/reportUtils";


export default {
  data() {
    return {
      flows: undefined,
      manifestation: undefined,

      blocks: [1, 2, 3, 4, 5],
      showReport: false,
      uploading: false,
      loading: true,

      manifestationOptions: [
        {title: '警醒度', key: 'vigilance', score: '良好',},
        {title: '配合度', key: 'blendage', score: '良好',},
        {title: '注意力', key: 'attention', score: '良好',},
        {title: '情绪', key: 'emotions', score: '良好',},
        {title: '主动性', key: 'initiative', score: '良好',},
        {title: '互动性', key: 'initiative_loop', score: '良好',},
      ],
      manifestations: [
        {title: '警醒度', key: 'vigilance', score: '良好',},
        {title: '配合度', key: 'blendage', score: '良好',},
        {title: '注意力', key: 'attention', score: '良好',},
        {title: '情绪', key: 'emotions', score: '良好',},
        {title: '主动性', key: 'initiative', score: '良好',},
        {title: '互动性', key: 'initiative_loop', score: '良好',},
      ],
    };
  },

  mounted() {
    this.fetchTestDetail();
  },

  methods: {

    async onUploadButton() {
      if (this.uploading) return;

      this.uploading = true;
      const testId = this.$route.params.test_id;
      const token = localStorage.getItem(`${testId}_token`);

      const manifestationPayload = {};

      this.manifestations.forEach((item) => {
        manifestationPayload[item.key] = item.score
      });
      console.log('this.manifestations', this.manifestations);
      console.log('manifestationPayload', manifestationPayload);
      try {
        const reqdata={
          test_id: testId,
          manifestation: manifestationPayload,
          status: "Close"
        };
        const res = await this.axios({
          url: `${portalUrl}swam/r/update`,
          headers: {token: token},
          data: reqdata,
          method: 'POST',
        });
        console.log('reqdata', reqdata);
        if (res.data.success) {
          this.showReport = true;
        } else {
          this.$notify({group: "foo", title: "提示", text: "提交失败，请重试！"});
        }
      } catch (e) {
        this.$notify({group: "foo", title: "提示", text: "网络错误，请重试！"});
      } finally {
        this.uploading = false;
      }
    },


    async fetchTestDetail() {
      this.loading = true;
      const testId = this.$route.params.test_id;
      const token = localStorage.getItem(`${testId}_token`);
      try {
        const res = await this.axios({
          url: `${portalUrl}swam/t/info`,
          headers: {
            token,
          },
          params: {
            test_id: testId,
          },
          method: 'GET',
        });
        //console.log(res.data);
        if (res.data.success) {
          const data = res.data.data;
          this.flows = data.learning_flows;
          this.manifestation = data.learning_flows
          if (data.learning_flows) {
            console.log(data)
            this.showReport = data.status !== 'Active';
          } else {
            this.$notify({group: 'foo', title: '提示', text: '请求数据失败，请重试！'});
          }
        }
      } catch (e) {
        this.$notify({group: 'foo', title: '提示', text: '网络错误，无法获取报告数据！'});
        console.error('Error fetching test detail s:', e);
      } finally {
        this.loading = false;
      }
    },
// --- 数据转换/重组 ---

    /**
     * 处理单个词语流程的准确率计算。
     * @param {Array} flows - 流程数组
     * @param {number} type - 流程类型 (0, 1, 2, 3)
     * @returns {Array<object>} 包含每个词语及其准确率的数组
     */
    _reformatWordAccuracy: function (flows, type) {
      if (!flows) return [];
      const filteredFlows = flows.filter(flow => flow.type === type);
      return filteredFlows.map(flow => {
        const result = flow.actions.groupBy(a => a.action_name);
        const accuracys = calculateAccuracy(result);
        return {
          letter: pinyin(flow.word, {pattern: "initial", type: "array"})[0],
          initial: flow.initial,
          word: flow.word,
          word_id: flow.word_id,
          accuracys: accuracys,
        };
      }).filter(flows => flows.accuracys);
    },
  },
  computed: {
    /** 目标声母训练的原始词语数据 (Type 0) */
    type0WordAccuracies() {
      return this._reformatWordAccuracy(this.flows, 0)
    }
    ,


    /** 韵母结合训练的原始词语数据 (Type 1, 2, 3) */
    typeRightWordAccuracies() {
      return [
        {type: 1, flows: this.flows.filter(f => f.type === 1)},
        {type: 2, flows: this.flows.filter(f => f.type === 2)},
        {type: 3, flows: this.flows.filter(f => f.type === 3)},
      ];
    }
    ,


    // === 报告分组数据 (Sections) ===

    /** 报告第三部分：全流程总统计 (Third Sections) */
    thirdSections() {
      if (!this.flows) return [];
      let allActions = [];
      this.flows.forEach(f => {
        allActions = [...allActions, ...f.actions];
      });

      const result = allActions.groupBy(a => a.action_name);
      return calculateAccuracy(result);
    }
    ,

    /** 报告头部显示的总体正确率（模板直接使用） */
    totalRatio() {
      return this.thirdSections?.[0]?.ratio.toFixed(0) ?? 'N/A';
    }
    ,

    /** 报告第一部分：按声母分组的每个词语的训练情况 (First Sections) */
    firstSections() {
      // console.log("type0WordAccuracies", this.type0WordAccuracies.length)
      if (!this.type0WordAccuracies.length) return [];

      const groupedObj = this.type0WordAccuracies.groupBy(f => f.letter);
      //console.log("groupedObj", groupedObj)
      const obj = Object.keys(groupedObj).map(f => ({
        letter: f,
        rows: groupedObj[f],
      }));
      return obj;
    }
    ,

    /** 报告第二部分：目标声母整体训练情况 (Second Sections) */
    secondSections() {
      if (!this.flows) return [];
      const type0Flows = this.flows.filter(f => f.type === 0);
      // console.log("type0Flows", type0Flows)
      // 使用辅助函数按 'letter' 键聚合
      const ag = aggregateFlows(type0Flows, 'initial');
      //console.log("ag", ag)
      return ag;
    }
    ,

    /** 报告主体：韵母结合的训练情况 (Sections2) */
    sections2() {
      const titles = [
        '单韵母结合的训练情况',
        '复韵母结合声母的训练情况',
        '单韵母结合声母的训练情况',
      ];

      return this.typeRightWordAccuracies.map((data, index) => {
        const wordAccuracies = this._reformatWordAccuracy(data.flows, data.type);

        // section.one: 按韵母整体聚合的训练情况
        const sectionOneItems = aggregateFlows(data.flows, 'initial');

        // section.two: 按韵母分组，展示每个词语的训练情况
        const groupedWordAccuracies = wordAccuracies.groupBy(f => f.initial);
        const sectionTwoItems = Object.keys(groupedWordAccuracies).map(initial => ({
          letter: initial,
          rows: groupedWordAccuracies[initial],
        }));
        const obj = {
          one: {
            items: sectionOneItems,
            title: titles[index],
          },
          two: {
            items: sectionTwoItems,
            title: titles[index],
          },
        };
        // console.log("sections2:obj", obj)
        return obj;
      });
    }
    ,

    // 模板优化：过滤掉 sections2 中没有数据的项
    filteredSections2() {
      const obj = this.sections2.filter(s => s.one.items.length > 0);
      return obj;
    }
  }
  ,
}
</script>

<style scoped>
.row-square > .s-row {
  display: flex;
  flex-direction: row;
  margin-top: 20px;
}

.title-word {
  width: 25% !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.col-titles-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.col-titles-row > div {
  width: 25%;
  font-size: 12px;
}

.q-row {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #279fb1;
  color: white;
  font-weight: bold;
}

.row-square > .s-row > .word {
  width: 72px;
  height: 25px;
  background-color: #f0f0f0;
}

.row-square {
  padding: 20px;
  width: calc(100vw - 40px);
  box-sizing: border-box;
}

.row-square > .s-row > .right {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-left: 10px;
  box-sizing: border-box;
  margin-top: -10px;
}

.row-square > .s-row > .right > .right-row > .pro-back {
  height: 50px;
  background-color: transparent;
  border-radius: 25px;
  position: relative;
  margin-bottom: 10px;
  display: flex;
  overflow: hidden;
  flex: 1;
}

.main {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(to right, #ffe0d9, #a4e0e9);
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: scroll;
}

.bottom-back {
  background-color: #e7fcff;
  min-height: auto;
  margin-top: 160px;
  box-sizing: border-box;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
}

.header {
  background-color: white;
  width: calc(100% - 30px);;
  margin: -100px 15px 0 15px;
  height: 126px;
  box-sizing: border-box;
  z-index: 100;
  border-radius: 20px;
  box-shadow: 5px -5px #279fb1;
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-end;
}

.header > .total-text {
  font-size: 35px;
  color: #333;
  font-weight: bolder;
  text-align: left;
  margin: 0;
  padding: 0;
}

.header > .header-item > .total-text > span {
  font-size: 15px;
  font-weight: normal;
}

.header-item {
  display: inline-flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.header-item-1 > .total-text {
  font-size: 24px;
}

.header-item-1 > h4 {
  font-size: 10px;
  font-weight: normal;
}

.big-title {
  font-size: 40px;
  font-weight: bold;
}

h1,
h4,
h5 {
  padding: 0;
  margin: 0;
  z-index: 100;
}

.sub-title {
  margin-top: 20px;
}

.letter-rows {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 20px;
}

.letter-rows > .item {
  width: calc((100vw - 40px) / 2);
  height: 144px;
  background-color: #e7fcff;
  z-index: 100;
  margin-left: 10px;
  margin-bottom: 10px;
  border-radius: 20px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.letter-rows > .item > h5 {
  font-size: 0.8em;
  font-weight: bold;
}

.letter-circle {
  background-color: #279fb1;
  color: white;
  width: 48px;
  height: 48px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 6px;
}

.row-square {
  width: calc(100vw - 20px);
  background-color: white;
  z-index: 100;
  margin-left: 10px;
  margin-top: 20px;
  border-radius: 20px;
}

.top-back {
  position: fixed;
  background-color: transparent;
  border: none;
  z-index: 10000;
}

.top-back > img {
  width: 77px;
  height: 44px;
}

.title-header {
  margin-top: 30px;
  margin-bottom: 10px;
}

.input-row {
  width: calc(100vw - 30px);
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  align-items: center;
  margin-bottom: 20px;
  margin-left: 15px;
}

.input-row > label {
  width: 90px;
  font-size: 20px;
  font-weight: bold;
}

.input-row > select {
  height: 65px;
  flex: 1;
  border: none;
  border-radius: 32.5px;
  background-color: white;
  padding: 20px;
  box-sizing: border-box;
  font-size: 20px;
  font-weight: bold;
  color: #7b7b7b;
  border-right: 16px solid transparent;
}

.star-button {
  height: 64px;
  width: calc(100vw - 80px);
  border-radius: 32px;
  background-color: #279fb1;
  border: none;
  font-size: 22px;
  font-weight: bolder;
  color: white;
  margin-left: auto;
  margin-right: auto;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  overflow: hidden;
  margin-top: 40px;
}

.loader {
  width: 30px;
  aspect-ratio: 1;
  display: grid;
  border-radius: 50%;
  background: linear-gradient(
      0deg,
      rgb(0 0 0/50%) 30%,
      #0000 0 70%,
      rgb(0 0 0/100%) 0
  ) 50%/8% 100%,
  linear-gradient(90deg, rgb(0 0 0/25%) 30%, #0000 0 70%, rgb(0 0 0/75%) 0) 50%/100% 8%;
  background-repeat: no-repeat;
  animation: l23 1s infinite steps(12);
}

.loader::before,
.loader::after {
  content: '';
  grid-area: 1/1;
  border-radius: 50%;
  background: inherit;
  opacity: 0.915;
  transform: rotate(30deg);
}

.loader::after {
  opacity: 0.83;
  transform: rotate(60deg);
}

@keyframes l23 {
  100% {
    transform: rotate(1turn);
  }
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  height: 64px;
  width: calc(100vw - 80px);
  margin-top: 40px;
}

.block-item {
  background-color: #279fb1;
  width: 20%;
  height: 60px;
  margin-right: 2px;
}

.ending {
  width: 50px;
  display: flex;
  flex-direction: column;
  margin-left: 2px;
}

.right-row {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
}

.small-text {
  font-size: 7px;
}

.section-back {
  background-color: rgba(255, 255, 255, 0.5);
  padding: 10px 0;
  margin-top: 15px;
  border-radius: 10px;
  padding-bottom: 20px;
}

.row-sq-2 {
  margin-top: 4px;
}
</style>
